<div class="attachments">
  <input nbInput fieldSize="small" style="width: 100%" placeholder="Поиск вложений" i18n-placeholder="@@SearchVersion" (keyup)="filterSidebarFilter($event)"/>

  <span class="files-counter">
		<nb-icon icon="attach-outline"/>
    {{ damItemVersions?.length }} {{ createLabel(damItemVersions.length, 'версия|версии|версий') }}
	</span>

  <div class="attachments-checkboxes">
    <ng-container *ngFor="let file of fileExtensions; index as i">
      <nb-checkbox (checkedChange)="onFileExtensionToggle(i)">
        {{ file?.typeOfFile }} ({{ file?.count }})
      </nb-checkbox>
    </ng-container>
  </div>

  <div class="attachments-list" *ngIf="damItemVersions && damItemVersions?.length>0" cdkDropList (cdkDropListDropped)="drop($event)">
    <ng-container *ngFor="let version of filterVersions(damItemVersions)">
      <ng-container *ngIf="version?.hideExpression==undefined || version.hideExpression==false">
        <div class="attachments-item" [ngClass]="{
            'active': version.id === currentVersion
          }" (click)="selectVersion(version)" cdkDrag>
          <div class="attachments-item__row">
            <div class="attachments-item__img-container">
              <app-secured-image *ngIf="damService.showThumbnail(version.mimeType)" src="/dam/get-image-dynamic-version/{{version.id}}"/>
              <img *ngIf="!damService.showThumbnail(version.mimeType)" style="max-width: 100px;object-fit: contain;width: 100%;height: 100%;" src="/assets/images/vivid/{{damService.getExtension(version)}}.svg" alt=""/>
            </div>

            <div>
              <button nbButton size="small" status="primary" (click)="download(version.id, version.header)">
                <nb-icon icon="download"/>
                <span i18n="@@Download">Скачать</span>
              </button> &nbsp;
              <button nbButton size="small" (click)="getExif(version.id, version?.iid); windowService.open(ExifDialog)">
                Exif
              </button>
            </div>
          </div>

          <hr/>

          <span class="attachments-item__row">
            {{ version.header }} <a nbTooltip="Переименовать" i18n-nbTooltip="@@Rename" class="pointer cursor-pointer" (click)="modalRename(version)"><nb-icon icon="edit"></nb-icon></a>
				</span>

          <div class="attachments-item__row">
            <div class="attachments-item-characteristics">
						<span [ngClass]="version?.header.split('.').pop()">
							.{{ version?.header.split('.').pop() }}
						</span>
              <!--            <span class="clr-black-sec">-->
              <!--							1875 x 1875 px-->
              <!--						</span>-->
              <span>
							{{ formatBytes(version?.size) }}
						</span> <span>
							{{ version.createdAt | date : 'dd.MM.yyyy' }}
						</span>
            </div>

            <span (click)="getHistory(version); windowService.open(VersionHistoryDialog);" class="attachments-item-change-history text-muted" i18n="@@ProductChanges">
						История изменений
					</span>
          </div>
        </div>

      </ng-container>
    </ng-container>
  </div>
</div>
<div class="attachments-list" *ngIf="damItemVersions && damItemVersions?.length==0">
  <div>Версий не найдено</div>
</div>

<ng-template #ExifDialog>
  <h2><span i18n="@@VersionExif">Exif данные версии</span>: {{ exifIid }} </h2>

  <div class="dialog-list">
    <ng-container *ngIf="documentExifList?.length; else noExif">
      <div class="exif-item" *ngFor="let exif of documentExifList">
        <div>
          {{ exif.tag }}
        </div>
        <div>
          {{ exif.description }}
        </div>
        <div>
          {{ exif.directory }}
        </div>
      </div>
    </ng-container>

    <ng-template #noExif>
      <div i18n="@@ExifIsMissing">
        Exif отсутствует
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #VersionHistoryDialog>
  <h2 i18n="@@History">История версий DAM элемента </h2>

  <div class="dialog-list">
    <ng-container *ngIf="damItemVersions?.length; else noVersion">
      <div class="version-item" *ngFor="let version of versionsHistory;">
        <app-secured-image *ngIf="damService.showThumbnail(version.mimeType)" src="/dam/get-image-dynamic-version-history/{{version.id}}"/>
        <img *ngIf="!damService.showThumbnail(version.mimeType)" style="max-width:100px" src="/assets/images/vivid/{{damService.getExtension(version)}}.svg" alt="">

        <div class="f-main version-item-info">

          <div *ngIf="clickedDamItemVersion.documentId === version.documentId" style="color:forestgreen">
              <span class="version-item-info__version" [ngClass]="'is-actual'" i18n="@@ActualVersion">
							Актуальная версия
						</span></div>

          <div *ngIf="clickedDamItemVersion.documentId !== version.documentId" style="color:forestgreen">
            <a *ngIf="write" (click)="makeActual(version.id)" nbButton>Сделать версию актуальной</a>
          </div>

          <div>
            {{ version.header }} {{ version.iid }}
          </div>
          <div>
            {{ version.mimeType }}  {{ formatBytes(version?.size) }}
          </div>

          <div>
							<span class="text-muted" i18n="@@Sorting_updatedAt_desc">
								Дата изменений
							</span> <span> </span>{{ version.createdAt | date: 'dd.MM.yyy hh:mm' }}
            <nb-icon icon="person-outline"/>
          </div>
          <div>
							<span class="text-muted" i18n="@@Updated">
								Дата загрузки
							</span> <span>
								{{ version.createdAt | date: 'dd.MM.yyy hh:mm' }}
            <nb-icon icon="person-outline"/>
							</span>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noVersion>
      <h6>Нет версий </h6>
    </ng-template>

    <div *ngIf="write" style="margin-top: 16px;">
      <label for="version-history-upload" class="well my-drop-zone" ng2FileDrop [ngClass]="{'file-over': true}" (onFileDrop)="upload()" [uploader]="uploader" i18n="@@ClickOrDragDocument">
        Кликните или перетащите сюда версию документа
      </label>
      <input type="file" ng2FileSelect (change)="upload()" [uploader]="uploader" multiple id="version-history-upload" style="display:none"/>
    </div>
  </div>
</ng-template>
